import * as React from 'react';
import { css, html } from 'react-strict-dom';

import { type ModalSize } from './Modal';

type Props = {
  /** Matches the Modal it sits in; a confirm dialog has no header to sit under. */
  size?: ModalSize;
  children: React.ReactNode;
};

export default function ModalBody({ size = 'form', children }: Props) {
  return (
    <html.div style={[styles.body, size === 'confirm' && styles.confirm]}>
      {children}
    </html.div>
  );
}

const styles = css.create({
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingTop: 16,
    paddingInline: 20,
  },
  confirm: {
    gap: 8,
    paddingTop: 24,
  },
});
